/*
 * @Description:
 * @Date: 2022-12-02 13:52:27
 */
import { DefineComponent } from 'vue';
import paymentAmount from './paymentAmount.vue';
export const PaymentAmount = paymentAmount as unknown as DefineComponent<any>;
